import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const About = () => (
  <section id="about" className="py-24 lg:py-32 px-6 sm:px-12 max-w-3xl mx-auto text-center" data-testid="about-section">
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.9, ease: EASE }}
      className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#808080]"
    >
      About SANTELQ
    </motion.p>
    <motion.h2
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: EASE, delay: 0.1 }}
      className="font-display font-semibold tracking-tight text-[#3A3A3C] text-3xl sm:text-4xl leading-[1.15] mt-4"
    >
      Healthcare, without the wait.
    </motion.h2>
    <motion.p
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: EASE, delay: 0.2 }}
      className="text-base text-[#474747] leading-relaxed mt-6"
      data-testid="about-copy"
    >
      SANTELQ Inc. is a company with one simple goal: make a basic health check as easy as
      grabbing a coffee. The Hub brings hospital-grade testing into clinics, offices and public
      spaces — so more people get checked, more often, and small problems get caught early.
    </motion.p>
  </section>
);
